"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluralityPreferNonEmptyAutoResolvePolicy = exports.AutoResolvePolicy = void 0;
class AutoResolvePolicy {
}
exports.AutoResolvePolicy = AutoResolvePolicy;
class PluralityPreferNonEmptyAutoResolvePolicy extends AutoResolvePolicy {
    pick(candidates) {
        const nonEmpty = candidates.filter((candidate) => candidate.normalizedValue !== '');
        const pool = nonEmpty.length > 0 ? nonEmpty : candidates;
        let winner = pool[0];
        for (const candidate of pool) {
            if (winner === undefined || candidate.voteCount > winner.voteCount) {
                winner = candidate;
            }
        }
        return winner?.value;
    }
}
exports.PluralityPreferNonEmptyAutoResolvePolicy = PluralityPreferNonEmptyAutoResolvePolicy;
//# sourceMappingURL=auto-resolve-policy.js.map